import { indexes } from '@mab-common/utils'

import type { QueryDslQueryContainer } from '@elastic/elasticsearch/lib/api/types'

import {
  buildElasticResultSourceFields,
  buildElasticSortFields,
} from '~/services/elastic/builder'
import { useElasticQuery } from '~/services/query/use-elastic-query'
import EsIndexTypes = indexes.EsIndexTypes
import RecordTypes = indexes.RecordTypes

export default function useArtworksCatalogue(
  filterQueries: QueryDslQueryContainer[] = [],
  pageSize = 12
) {
  return useElasticQuery<any>(RecordTypes.PROFILE_IMAGE, {
    index: EsIndexTypes.ARTWORKS,
    searches: [
      {},
      {
        from: 0,
        size: pageSize,
        sort: buildElasticSortFields(RecordTypes.ARTWORK),
        _source: buildElasticResultSourceFields(RecordTypes.ARTWORK),
        query: {
          bool: {
            must_not: [
              {
                term: {
                  isVisible: false,
                },
              },
            ],
            filter: [
              {
                term: {
                  type: RecordTypes.ARTWORK,
                },
              },
              ...filterQueries,
            ],
          },
        },
      },
    ],
  })
}
